module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/mobile-fb2bfb6ce6effcf44d57289bdd05e0a3.jpeg";